import React from 'react'
import { ButtonBase } from '@material-ui/core'
import Distance from '../../../assets/images/Instructions-Distance.png'
import Timer from '../../../assets/images/TimerIcon.png'
import TwoThumbs from '../../../assets/images/TwoThumbsIcon.png'
import Reposition from '../../../assets/images/RepositionIcon.svg'
import Boost from '../../../assets/images/BoostIcon.png'
import Shield from '../../../assets/images/ShieldIcon.png'
import MoreTime from '../../../assets/images/MoreTimeIcon.png'
import CloseButton from '../CloseButton'

// Slick Carousel
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

class NextButton extends React.Component {
  enterGame = () => {
    this.props.click(true)
  }

  play = () => {
    this.props.click('instructions', 'play')
  }
  
  render() {
    const { currentSlide, slideCount, onClick } = this.props
    const lastSlide = currentSlide === slideCount - 1

    const finalWording = this.props.showCloseButton ? 'Continue' : 'Play'
    const finalFunction = this.props.showCloseButton ? this.enterPause : this.enterGame

    return (
      <div className="button-container">
        <ButtonBase className="button" onClick={ lastSlide ? finalFunction : onClick } >
          { lastSlide ? finalWording : 'Next' }
        </ButtonBase>
        <span className={`${lastSlide ? 'hide' : 'skip-button'}`} onClick={ this.play }>SKIP</span> 
      </div>
    )
  }
}

class Instructions extends React.Component {
  state = {
    mounted: false,
  }

  settings = {
    dots: true,
    arrows: true,
    autplay: false,
    infinite: true,
    nextArrow: <NextButton click={() => { this.play() }} />
  }

  close = () => {
    this.props.action('help', 'close')
  }

  play = () => {
    if (this.props.action) {
      this.props.action('instructions', 'play')
    }
  }
  
  nextScreen = () => {
    if (this.props.action) {
      this.props.action(this.props.showCloseButton ? 'help' : 'instructions')
    }
  }

  componentDidMount () {
    this.setState({mounted: true})
  }

  render () {
    return (
      <div className={`instructions ${this.state.mounted ? 'mounted' : ''}`}>
        <Slider {...this.settings} >
          <div className='instruction-screen'>
            <div className="image-with-icon-container">
              <div className='image-with-icon'>
                <p>1000</p>
                <img src={Distance} alt='' />
              </div>
              <div className='image-with-icon'>
                <img id="timer" src={Timer} alt='' />
                <p>01:00</p>
              </div>
            </div>
            <p>Go fast and stay consistent before time runs out.</p>
          </div>

          <div className='instruction-screen'>
            <img id='two-thumbs' src={TwoThumbs} alt='' />
            <p>Tap the right and left sides of your screen to avoid obstacles.</p>
          </div>

          <div className='instruction-screen wide'>
            <h2>Power-Ups</h2>
            <div className='icon-wrapper'>
              <div className='icon-container'>
                <img id='speed' src={Boost} alt='' />
                <p>Boost your speed!</p>
              </div>
              <div className='icon-container'>
                <img id='shield' src={Shield} alt='' />
                <p>Crash through obstacles!</p>
              </div>
              <div className='icon-container'>
                <img id='more-time' src={MoreTime} alt='' />
                <p>Extend your time!</p>
              </div>
            </div>
          </div>

          <div className='instruction-screen wide'>
            <img id="reposition" src={Reposition} alt='' />
            <p>Tap this if you lose sight of your car.</p>
          </div>
        </Slider>
        { !this.props.showCloseButton ? '' : <CloseButton click={() => { this.close() }} />}
      </div>
    )
  }
}

export default Instructions